// 系统用户列表筛选条件
export let systemTableFilter = [
  {
    label: '类型',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'role',
    options: [],
    props: {
      label: 'displayName',
      value: 'id'
    }
  }
]
// 系统用户列表表头
export let customerTableLabels = [
  {
    label: '客户名称',
    value: 'base.name'
  },
  {
    label: '社会统一信用代码',
    value: 'base.secCode'
  },
  {
    label: '联系人',
    value: 'base.contact'
  },
  {
    label: '联系电话',
    value: 'base.mobile'
  }
]
